export const esPwa = {
  'pwa.close': 'Cerrar aviso',
  'pwa.hideInstall': 'Ocultar instalación',
  'pwa.install': 'Instalar',
  'pwa.installMessage': 'Instala FinanceGo para abrirla como una app.',
  'pwa.newVersion': 'Hay una versión nueva de FinanceGo.',
  'pwa.offline': 'Sin conexión. Puedes consultar datos guardados; los cambios requieren internet.',
  'pwa.offlineReady': 'FinanceGo está lista para abrirse sin conexión.',
  'pwa.registrationError':
    'No se pudo activar el modo instalable. Recarga la página para reintentarlo.',
  'pwa.status': 'Estado de la aplicación',
  'pwa.update': 'Actualizar',
} as const;

export const enPwa: Record<keyof typeof esPwa, string> = {
  'pwa.close': 'Close notice',
  'pwa.hideInstall': 'Hide installation',
  'pwa.install': 'Install',
  'pwa.installMessage': 'Install FinanceGo to open it like an app.',
  'pwa.newVersion': 'A new FinanceGo version is available.',
  'pwa.offline': 'Offline. You can view saved data; changes require an internet connection.',
  'pwa.offlineReady': 'FinanceGo is ready to open offline.',
  'pwa.registrationError': 'Installable mode could not be enabled. Reload the page to try again.',
  'pwa.status': 'Application status',
  'pwa.update': 'Update',
};
